import { useNavigate } from "react-router-dom";
import { useAuth } from "./useAuth";
import { useAuthDIContext } from "@/features/auth";
import { toast } from "sonner";
import { announceIdentity } from "@/shared/infra/auth/crossTabIdentity";

export default function useLogOut() {
    const { logout } = useAuth();
    const navigate = useNavigate();
    const authDIContext = useAuthDIContext();

    const handleLogOut = async () => {

        try {
            await authDIContext!.authUseCase.logout();
        } catch (error) {
            toast.error('Logout failed');
        } finally {
            // The cookie is gone for the whole browser, not just this tab.
            announceIdentity(null);
            logout();
            navigate('/login');
        }
    };

    return { handleLogOut };
}